import { Box } from '@mui/material';
import ExoWorkday from '../exo/ExoWorkday';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import ExoForm from '../exo/ExoForm';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const NewTimeCorrection = ({
  onCreate,
  onCancel,
  onFeedback = () => {},
  userId,
  date,
  autoAccept,
}) => {
  const config = useConfig();
  const { t } = useTranslation();

  const [newDate] = useState(date ? date : moment().format('YYYY-MM-DD'));

  const [startDate, setStartDate] = useState(
    newDate ? moment(newDate).format('YYYY-MM-DD') : null
  );

  useEffect(() => {
    if (newDate) setStartDate(moment(newDate).format('YYYY-MM-DD'));
  }, [newDate]);

  function handleSubmit(times, data) {
    DBRequest({
      config,
      path: 'employeerequests',
      method: API_POST({
        userId,
        corrections: times,
        type: 'timeCorrection',
        comment: data?.comment ? data.comment : null,
        autoAccept: Boolean(autoAccept),
      }),
      onResponse: handleCreation,
      onFeedback,
    });
  }

  function handleCreation(data) {
    onCreate(data.data);
    onCancel();
  }

  function handleRangeChange(data) {
    setStartDate(data.startDate);
  }

  return (
    <Box className="z-10 w-full p-4 h-full flex flex-col overflow-hidden gap-2">
      <ExoForm
        fields={[{ type: 'date', key: 'startDate', label: t('Date') }]}
        onChange={handleRangeChange}
        startDataCollection={{
          startDate,
        }}
        outerClassName="flex flex-col"
        noControls
      />
      <ExoWorkday
        labelFormat="dddd"
        onCancel={onCancel}
        format="DD.MM.YYYY"
        onSubmit={handleSubmit}
        userId={userId}
        dateStart={startDate}
        edit
        hourStart={5}
        hourEnd={22}
      />
    </Box>
  );
};

export default NewTimeCorrection;
